import { Box, IconButton, Typography } from '@material-ui/core'
import { ArrowBack as BackIcon } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'

const Bookmarks = ({ bookmarks }) => {
    const history = useHistory();

    const gotoDef = word => history.push(`/search/${word}`);
    return (
        <>
            <Box display="flex" alignItems="center" mb={2}>
                <IconButton onClick={history.goBack} sx={{ color: 'black', mr: 1 }}><BackIcon /></IconButton>
                <Typography variant="h6">Bookmarks</Typography>
            </Box>

            {Object.keys(bookmarks).map(b => <Box
                onClick={() => gotoDef(b)}
                key={b} sx={{
                    p: 2,
                    cursor: 'pointer',
                    backgroundColor: 'white',
                    borderRadius: 1,
                    textTransform: 'capitalize',
                    typography: 'subtitle1',
                    mb: 2
                }}>{b}</Box>)}
        </>
    )
}

export default Bookmarks
